<!-- eslint-disable max-lines -->
<template>
  <div class="adv-prod-page">
    <div class="query-conditions">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item>
          <el-date-picker
            v-model="query._date"
            clearable
            type="daterange"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 260px"
            @change="handleFilter"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="query.adv_ids"
            clearable
            placeholder="请输入广告主编号"
            style="width: 280px"
            @keyup.enter.native="handleFilter"
            @input="handleNumberInput"
          />
        </el-form-item>
        <!-- <el-form-item>
          <el-input
            v-model.trim="query.company"
            clearable
            placeholder="请输入广告主账户名"
            style="width: 280px"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item> -->
        <el-form-item>
          <el-input
            v-model.trim="query.product_names"
            clearable
            placeholder="请输入产品名"
            style="width: 280px"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="query.account_type"
            style="width: 140px"
            clearable
            placeholder="广告主类型"
            @change="handleFilter"
          >
            <el-option
              v-for="v in type_ops"
              :key="v.id"
              :value="v.id"
              :label="v.text"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="query.has_products"
            style="width: 140px"
            clearable
            placeholder="是否有产品"
            @change="handleFilter"
          >
            <el-option
              v-for="v in yn_ops"
              :key="v.id"
              :value="v.id"
              :label="v.text"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-cascader
            v-model="query._cateIds"
            :options="cate_ops"
            :show-all-levels="false"
            collapse-tags
            placeholder="请选择行业分类"
            :props="{
              expandTrigger: 'hover',
              children: 'child',
              multiple: true,
              label: 'name'
            }"
            clearable
            @change="handleFilter"
          />
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="query.audit"
            style="width: 140px"
            clearable
            placeholder="状态"
            @change="handleFilter"
          >
            <el-option
              v-for="v in auditOptions"
              :key="v.value"
              :value="v.value"
              :label="v.label"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="query.agent_info"
            clearable
            placeholder="请输入聚合预算"
            style="width: 200px"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item>
        <!-- <el-form-item>
          <el-input
            v-model.trim="query.task"
            clearable
            placeholder="请输入任务"
            style="width: 200px"
            @keyup.enter.native="handleFilter"
          />
        </el-form-item> -->
        <el-form-item>
          <el-select
            v-model="query.task_id"
            filterable
            clearable
            style="width: 200px"
            remote
            :remote-method="querySearchTasks2"
            :loading="editProdTasksDlg2.searchLoading"
            placeholder="请输入任务"
          >
            <el-option
              v-for="item in editProdTasksDlg2.options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            v-model="query.sale_type"
            style="width: 140px"
            clearable
            placeholder="预算类型"
            @change="handleFilter"
          >
            <el-option
              v-for="v in budgetTypeSelection"
              :key="v.value"
              :value="v.value"
              :label="v.label"
            />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            :loading="table.loading"
            @click="handleFilter"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <div
      class="query-tool"
      style="margin-bottom: 16px;"
    >
      <el-button
        type="primary"
        size="small"
        @click="mulSyncProd"
      >
        批量同步产品
      </el-button>
    </div>

    <div
      v-loading="table.loading"
      class="query-data"
    >
      <el-table
        :data="table.list"
        style="width: 100%"
        stripe
        border
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="45"
          :selectable="row => !!row._prodName"
        />
        <el-table-column
          prop="adv_user_id"
          label="广告主编号"
          width="120"
        />
        <el-table-column
          prop="company"
          label="广告主账户名"
          width="120"
        />
        <el-table-column
          prop="category"
          label="分类"
        />
        <el-table-column
          prop="display_name"
          label="代理商名称"
        />
        <el-table-column
          prop="_prodName"
          label="待同步产品名称"
          width="250"
        >
          <template slot-scope="scope">
            <el-autocomplete
              v-model="scope.row._prodName"
              :fetch-suggestions="querySearchProdAsync"
              clearable
              size="small"
              placeholder="输入名称"
              @select="item => handleSelectProd(scope.row, item)"
            >
              <template slot-scope="{ item }">
                <div>{{ item.name }}</div>
              </template>
            </el-autocomplete>
            <div
              v-if="scope.row._prodName !== scope.row.promoting_product"
              class="tip-warning"
            >
              待同步名称与推广名称不一致
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="product_name"
          label="产品名称"
        />
        <el-table-column
          prop="promoting_product"
          label="推广产品"
        />
        <el-table-column
          prop="skip_media"
          label="跳过媒体"
        >
          <template slot-scope="scope">
            <el-checkbox
              v-model="scope.row.skip_media"
              :disabled="+scope.row.audit === 10"
              :true-label="1"
              :false-label="0"
            />
          </template>
        </el-table-column>
        <!-- <el-table-column
          prop="agent_info"
          label="聚合预算"
        >
          <template slot-scope="scope">
            <el-input
              v-model="scope.row.agent_info"
              placeholder="输入备注"
              @keyup.enter.native="() => updateAgentInfo(scope.row)"
            />
          </template>
        </el-table-column> -->
        <el-table-column
          prop="agent_info"
          label="聚合预算"
          width="150"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.agent_info"
              filterable
              clearable
              remote
              :remote-method="querySearchAgentInfo"
              placeholder="输入备注"
              :loading="editProdSalorDlg.searchLoading"
              @change="handleSelectChange(scope.row)"
              @clear="handleClear(scope.row)"
            >
              <el-option
                v-for="item in editProdSalorDlg.options"
                :key="item.id"
                :label="item.budget_name"
                :value="item.id"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="sale_type"
          label="预算类型"
          width="150"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.sale_type"
              clearable
              placeholder="请选择类型"
              :value="scope.row.sale_type || null"
              @change="val => updateBudgetType(scope.row, val)"
            >
              <el-option
                v-for="item in budgetTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          prop="task"
          label="任务"
          width="150"
        >
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.task_name"
              filterable
              clearable
              remote
              :remote-method="querySearchTasks"
              placeholder="输入任务"
              :loading="editProdTasksDlg.searchLoading"
              @change="(val) => updateTask(scope.row, val)"
            >
              <el-option
                v-for="item in editProdTasksDlg.options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </template>

          <!-- <template slot-scope="scope">
            <el-input
              v-model="scope.row.task"
              placeholder="输入任务"
              @keyup.enter.native="() => updateTask(scope.row)"
            />
          </template> -->
        </el-table-column>
        <el-table-column
          prop="audit"
          label="核验状态"
        >
          <template slot-scope="scope">
            {{ auditOptionsO[scope.row.audit].label }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="178"
        >
          <template slot-scope="scope">
            <el-button
              size="small"
              type="text"
              @click="syncProduct(scope.row)"
            >
              同步到产品
            </el-button>
            <el-button
              size="small"
              type="text"
              :disabled="+scope.row.audit !== 20"
              @click="stopProduct(scope.row)"
            >
              暂不处理
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="query.page"
        :page-sizes="[20, 30, 50, 100]"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        style="margin-top: 30px; float: right"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>
  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import DateUtil from '@/common/js/DateUtil';

const req = new Request();

// const
const YN_OPTIONS = {
  yes: { id: '1', text: '是' },
  no: { id: '2', text: '否' },
};

const TYPE_OPTIONS = {
  ka: { id: 2, text: 'KA端口' },
  smb: { id: 0, text: 'SMB端口' },
  bs: { id: 1, text: '创业端口' },
};
const AuditOptions = {
  10: {
    value: 10,
    label: '同步完成',
  },
  20: {
    value: 20,
    label: '待同步',
  },
  30: {
    value: 30,
    label: '暂不处理',
  },
};

export default {
  name: 'OperationManageAdvProd',
  data() {
    return {
      // ops
      yn_ops: Object.values(YN_OPTIONS),
      type_ops: Object.values(TYPE_OPTIONS),
      cate_ops: [],

      // list
      table: {
        list: [],
        selected: [],
        total: 0,
        loading: false,
      },
      auditOptionsO: AuditOptions,
      auditOptions: Object.values(AuditOptions),
      query: {
        _date: null,
        _cateIds: [],
        start_date: '',
        end_date: '',
        company: '',
        account_type: '',
        has_products: '',
        category_ids: '',
        audit: '',
        page: 1,
        page_size: 20,
        number: [],
        adv_ids: '',
        agent_info: '',
        task: '',
        product_names: '',
        sale_type: '',
      },

      // dlg
      syncProdDlg: {
        visible: false,
        form: {
          config: '',
        },
      },

      editProdSalorDlg: {
        searchLoading: false,
        options: [],
      },
      editProdTasksDlg: {
        searchLoading: false,
        options: [],
      },
      editProdTasksDlg2: {
        searchLoading: false,
        options: [],
      },
      budgetTypeOptions: [
        { value: 1, label: '直投' },
        { value: 2, label: '渠道' },
      ],
      budgetTypeSelection: [
        // { value: -1, label: '全部' },
        { value: 1, label: '直投' },
        { value: 2, label: '渠道' },
        { value: 0, label: '无' },
      ],
    };
  },

  created() {
    // 近30天
    this.query._date = [
      DateUtil.setDate(Number(new Date()), -30),
      DateUtil.setDate(Number(new Date())),
    ];
    this._getCateConf();
    this._getList();
  },
  methods: {
    // 新增预算类型更新方法
    async updateBudgetType(item, value) {
      try {
        await req.send(req.Apis.customer.common.updateBudgetType, {
          account_id: item.account_id,
          sale_type: value || 0, // 保持原有逻辑，如果接口需要0作为清除值
        });

        // 前端显示处理：将0转换为null
        item.sale_type = value === 0 ? null : value;
        this.$message.success('预算类型更新成功');
      } catch (err) {
        this.$message.error(`更新失败：${err.message || '未知错误'}`);
      }
    },

    async _getCateConf() {
      try {
        const res = await req.send(req.Apis.sales.common.category);
        this.cate_ops = [
          {
            child: res.data,
            name: '全部',
            value: -1,
          },
        ];
      } catch (err) {
        this.$message.error(`获取失败：${err.message || '未知错误'}`);
      }
    },
    handleNumberInput(value) {
      // 将输入的字符串转换为数组
      this.query.number = value
        .split(',')
        .map((s) => s.trim())
        .filter((s) => s);
    },
    async _getList() {
      try {
        this.table.loading = true;
        const _date = this.query._date || [];
        const params = {
          ...this.query,
          category_ids: this.query._cateIds
            .map((i) => i[i.length - 1])
            .join(','),
          start_date: _date[0] || '',
          end_date: _date[1] || '',
          adv_ids: this.query.number.join(','), // 将数组转换为逗号分隔的字符串
        };

        const res = await req
          .send(req.Apis.customer.common.getAdvProd, params)
          .fin(() => {
            this.table.loading = false;
          });

        const list = (res.data || {}).list || [];
        list.forEach((item) => {
          item._prodName = item.source_mark || '';
          if (item.audit !== 10) {
            item.skip_media = 1;
          }
          // 将字符串类型的 sale_type 转换为数字类型
          let saleType = parseInt(item.sale_type, 10);
          // 确保 sale_type 是有效的选项值
          let validValue = null;
          this.budgetTypeOptions.forEach((opt) => {
            if (opt.value === saleType) {
              validValue = opt.value;
            }
          });
          item.sale_type = validValue;
        });
        this.table.list = list;
        this.table.selected.length = 0;
        this.table.total = Number(res.data.total || 0);
      } catch (err) {
        this.$message.error(`获取列表失败：${err.message || '未知错误'}`);
      }
    },

    async _processSyncProd() {
      try {
        await req.send(
          req.Apis.customer.common.syncAdvProd,
          this.syncProdDlg.form,
        );
        this.$message.success('同步成功');
        this._getList();
      } catch (err) {
        this.$message.error(`同步失败：${err.message || '未知错误'}`);
      }
    },
    handleSelectChange(row) {
      // 找到对应的中文名
      const selectedOption = this.editProdSalorDlg.options.find(
        (option) => option.id === row.agent_info,
      );
      if (selectedOption) {
        this.updateAgentInfo({
          account_id: row.account_id,
          agent_info: selectedOption.budget_name,
          budget_id: selectedOption.id,
        });
      }
    },
    handleClear(row) {
      // 清空选择值
      row.agent_info = null;
      // 如果需要，可以调用 updateAgentInfo 方法来同步后端
      this.updateAgentInfo({
        account_id: row.account_id,
        agent_info: null,
        budget_id: null,
      });
    },

    // async updateAgentInfo(item) {
    //   const { account_id, agent_info } = item;
    //   try {
    //     await req.send(req.Apis.customer.common.updateAgentInfo, {
    //       account_id,
    //       agent_info,
    //     });
    //     this.$message.success('修改成功');
    //     this._getList();
    //   } catch (err) {
    //     this.$message.error(`修改失败：${err.message || '未知错误'}`);
    //   }
    // },
    async updateAgentInfo(item) {
      try {
        await req.send(req.Apis.customer.common.updateAgentInfo, {
          account_id: item.account_id,
          agent_info: item.agent_info,
          budget_id: item.budget_id,
        });
        this.$message.success('修改成功');
        this._getList();
      } catch (err) {
        this.$message.error(`修改失败：${err.message || '未知错误'}`);
      }
    },
    // 任务绑定
    async updateTask(item, val) {
      const { account_id } = item;
      try {
        await req.send(req.Apis.customer.common.updateTaskId, {
          account_id,
          task_id: val,
        });
        this.$message.success('修改成功');
        this._getList();
      } catch (err) {
        this.$message.error(`修改失败：${err.message || '未知错误'}`);
      }
    },

    _syncProd() {
      this.$confirm('即将同步名称, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this._processSyncProd();
      });
    },

    syncProduct(item = {}) {
      if (!item._prodName) return;
      this.syncProdDlg.form.config = `${item.adv_user_id}:${item._prodName}`;
      this.syncProdDlg.form.skip_media = item.skip_media;
      this._syncProd();
    },
    async stopProduct(item = {}) {
      try {
        await req.send(req.Apis.customer.common.stopProduct, {
          adv_user_id: item.adv_user_id,
        });
        this.$message.success('操作成功');
        this._getList();
      } catch (err) {
        this.$message.error(`操作失败：${err.message || '未知错误'}`);
      }
    },

    mulSyncProd() {
      if (!this.table.selected.length) return;
      this.syncProdDlg.form.config = this.table.selected
        .map((i) => `${i.adv_user_id}:${i._prodName}`)
        .join(',');
      this._syncProd();
    },

    querySearchProdAsync(keyword, cb) {
      if (!keyword) return cb([]);

      clearTimeout(this.querySearch);
      this.querySearch = setTimeout(() => {
        req
          .send(req.Apis.customer.common.searchProd, {
            name: keyword,
          })
          .then((res) => {
            cb(res.data || []);
          })
          .catch(() => {
            cb([]);
          });
      }, 100);
    },

    handleSelectProd(item, prod) {
      this.$set(item, '_prodName', prod.name);
    },

    // 输入并选择聚合预算下拉框
    async querySearchAgentInfo(key) {
      if (!key) return [];
      try {
        this.editProdSalorDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.budgetBind.list, {
            keyword: key,
            page: 1,
            page_size: 10000000000,
            status: 1,
          })
          .fin(() => {
            this.editProdSalorDlg.searchLoading = false;
          });
        this.editProdSalorDlg.options = res.data.list || [];
      } catch (err) {
        this.$message.error(`获取聚合预算失败：${err.message || '未知错误'}`);
      }
    },

    // 输入并选择任务下拉框
    async querySearchTasks(key) {
      if (!key) return [];
      try {
        this.editProdTasksDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.taskTag.list, {
            keyword: key,
            page: 1,
            page_size: 10000000000,
            status: 1,
          })
          .fin(() => {
            this.editProdTasksDlg.searchLoading = false;
          });
        this.editProdTasksDlg.options = res.data.list || [];
      } catch (err) {
        this.$message.error(`获取任务列表失败：${err.message || '未知错误'}`);
      }
    },
    // 输入并选择任务下拉框
    async querySearchTasks2(key) {
      if (!key) return [];
      try {
        this.editProdTasksDlg2.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.taskTag.list, {
            keyword: key,
            page: 1,
            page_size: 10000000000,
            status: 1,
          })
          .fin(() => {
            this.editProdTasksDlg2.searchLoading = false;
          });
        this.editProdTasksDlg2.options = res.data.list || [];
      } catch (err) {
        this.$message.error(`获取任务列表失败：${err.message || '未知错误'}`);
      }
    },

    handleSelectionChange(items) {
      this.table.selected = items;
    },

    handleFilter() {
      this.query.page = 1;
      this._getList();
    },

    handlePageSizeChange(pageSize) {
      this.query.page_size = Number(pageSize);
      this._getList();
    },

    handleQueryPage(page) {
      this.query.page = Number(page);
      this._getList();
    },
  },
};
</script>
<style lang="less">
.adv-prod-page {
  .tip-warning {
    font-size: 12px;
    color: #ff0000;
  }
}
</style>
